<template>
  <DefaultLayout :disableFacilitatorTools="true">
    <span v-if="showContents">
      <div v-if="!observerFacilitator">
        <div class="text-center" v-if="$store.getters.getIsFacilitator">
          <base-button
            style="white-space: normal;margin: 8px"
            type="primary"
            size="lg"
            @click="$router.push('/admin/games/')"
            >{{ $t("simulationadmin") }}</base-button
          ><br />
          <OpenAdminGuideButton />
          <LogoutButton />
        </div>

        <br />

        <div class="text-center">
          <div class="row">
            <div class="col-sm-2"></div>
            <div class="col-sm-8">
              <div class="col-sm" v-if="!$store.getters.isLoggedIn">
                <base-button size="lg" type="primary" v-on:click="login()">{{
                  $t("login")
                }}</base-button>
              </div>

              <br />
              <div class="alert alert-primary" role="alert" v-if="alertMessage">
                {{ $t(alertMessage) }}
              </div>
              <br />
              <small class="font-weight-bold">
                {{ $t("gamecode") }}
                <a href="#" @click="showGameCode()">
                  {{ $t("gamecodelink") }}
                </a>
              </small>
              <span v-if="showCode">
                <base-input
                  maxLength="50"
                  ref="gamecode"
                  id="input-gamecode"
                  v-model="form.game_code"
                  v-bind:placeholder="$t('entercode')"
                  v-on:keyup.native.enter="onSubmit"
                />
                <base-button
                  type="primary"
                  :disabled="disableSubmit"
                  v-on:click="onSubmit()"
                  size="sm"
                  >{{ $t("submit") }}</base-button
                >
              </span>
              <br />
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="alert alert-primary" role="alert">
          {{ $t("observerfacilitator") }}
        </div>
      </div>
    </span>
    <span v-else>
      <div class="spinner-border" role="status"></div>
    </span>
  </DefaultLayout>
</template>

<script>
import Vue from "vue";
import {
  getGameByGameCode,
  getAndCommitGameByGameCode,
  getAndCommitScenario,
  getAndCommitCases,
  getAndCommitRPSCases,
  getAndCommitRPSScenario,
  getAndCommitRPSCaseChoices,
  getAndCommitRPSAnswersByGame,
  getPlayerByReturnCode
} from "../services/APIService";
import DefaultLayout from "@/layouts/DefaultLayout.vue";
import OpenAdminGuideButton from "@/components/OpenAdminGuideButton.vue";
import LogoutButton from "@/components/LogoutButton.vue";

export default {
  components: { DefaultLayout, OpenAdminGuideButton, LogoutButton },
  data: function() {
    return {
      focused: true,
      form: {
        game_code: ""
      },
      alertMessage: null,
      disableSubmit: false,
      showCode: false,
      observerFacilitator: false,
      showContents: false,
      return_code: null
    };
  },
  props: {
    gameCode: {}
  },
  computed: {
    browserIsIE() {
      // https://stackoverflow.com/questions/19999388/check-if-user-is-using-ie
      const ua = window.navigator.userAgent;
      const msie = ua.indexOf("MSIE ");

      if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv:11\./)) {
        // Is IE
        return true;
      } else {
        return false;
      }
    }
  },
  async mounted() {
    if (this.$route.name === "observe" && this.$store.getters.isLoggedIn) {
      // facilitators can't act as observers
      this.observerFacilitator = true;
      this.showContents = true;
      return;
    }

    this.$store.commit("reinitializeStore");

    if (this.browserIsIE) {
      this.alertMessage = this.$t("noie");
    }

    this.form.game_code = this.$route.params.gamecode;

    if (!this.$store.getters.getIsFacilitator) {
      this.return_code = this.$route.params.returncode;
    }

    if (this.form.game_code) {
      this.form.game_code = this.form.game_code.toLowerCase();

      this.$store.dispatch("log", "Game code " + this.form.game_code + " received in URL.");

      // Let's just "submit"
      this.onSubmit();
    } else {
      // No game code, if logged in facilitator let's go to games list
      this.showContents = true;

      if (this.$store.getters.isLoggedIn) {
        this.$router.push("/admin/games/");
      }
    }
  },
  methods: {
    login() {
      this.$router.push("/admin/login");
    },
    async onSubmit() {
      if (!this.form.game_code) {
        this.alertMessage = "nogamecode";
        this.showContents = true;
        return;
      }

      const game = await getGameByGameCode(this.form.game_code, this);

      if (game) {
        if (game.last_page_shown && !this.$store.getters.getIsFacilitator) {
          // Cannot join anymore the game, however if there is a return code we can push the player to reporting
          if (this.return_code && game.reporting_open) {
            const player = await getPlayerByReturnCode(this.form.game_code, this.return_code);

            if (player) {
              let url = "";
              if (game.simulation_type === "rockpaperscissors") {
                url += "/rps";
              }
              url += "/reporting/reportingcode/";
              url += player.reporting_code;

              this.$router.push(url);
              return;
            }
          }

          this.alertMessage = "cannotjoinanymore";
          this.showContents = true;
        } else {
          this.gameCodeFound(this.form.game_code);
        }
      } else {
        this.alertMessage = "notfound";
        this.form.game_code = "";
        this.showContents = true;
      }
    },
    async gameCodeFound(gameCode) {
      // correct game Code entered, go to data gathering
      this.disableSubmit = true;

      if (this.$route.name === "observe") {
        this.$store.dispatch("log", "Observer mode activated.");

        this.$store.commit({
          type: "setPlayerIsObserver",
          playerIsObserver: true
        });
      }

      await getAndCommitGameByGameCode(gameCode, this.$store.commit);

      this.$store.commit({
        type: "setThisGameCode",
        gameCode: gameCode
      });

      await this.$store.dispatch("updatePlayers");

      if (this.$store.getters.getIsClassic) {
        // Classic simulation
        await getAndCommitCases(
          this.$store.state.main.game.scenario,
          this.$store.state.main.game.gameCode,
          this.$store.commit
        );
        await getAndCommitScenario(
          this.$store.state.main.game.scenario,
          gameCode,
          this.$store.commit
        );

        const p1 = this.$store.dispatch("updatePlayers");
        const p2 = this.$store.dispatch("updateSelfEvaluations");
        const p3 = this.$store.dispatch("updateAllNominations");
        const p4 = this.$store.dispatch("updateGame");
        const p5 = this.$store.dispatch("updateSurveyAnswers");

        Promise.all([p1, p2, p3, p4, p5]).then(resp => {
          this.$store.commit({
            type: "setSelectedLocale",
            selectedLocale: this.$store.state.main.game.defaultLocale
          });

          this.$store.dispatch({
            type: "initializeColors"
          });

          this.$store.commit("setGameLocales");

          if (!this.return_code) {
            this.$router.push("/intro");
          } else {
            this.$router.push("/welcome/returncode/" + this.return_code);
          }
        });
      } else {
        // Rock paper scissors simulation
        const p1 = getAndCommitRPSCases(
          this.$store.state.main.game.rpsScenario,
          this.$store.state.main.game.gameCode,
          this.$store.commit
        );

        const p2 = getAndCommitRPSScenario(
          this.$store.state.main.game.rpsScenario,
          gameCode,
          this.$store.commit
        );

        const p3 = getAndCommitRPSCaseChoices(
          this.$store.state.main.game.rpsScenario,
          gameCode,
          this.$store.commit
        );

        const p4 = getAndCommitRPSAnswersByGame(
          this.$store.state.main.game.id,
          this.$store.state.main.game.gameCode,
          this.$store.commit
        );

        Promise.all([p1, p2, p3, p4]).then(resp => {
          this.$store.commit({
            type: "setSelectedLocale",
            selectedLocale: this.$store.state.main.game.defaultLocale
          });

          this.$store.commit("setGameLocales");

          // No intro page for RPS
          if (!this.return_code) {
            this.$router.push("/welcome");
          } else {
            this.$router.push("/welcome/returncode/" + this.return_code);
          }
        });
      }
    },
    showGameCode() {
      this.showCode = true;
    }
  }
};
</script>

<i18n>
{
  "en": {
    "entercode": "* Please enter simulation code",
    "submit": "Submit",
    "notfound": "Simulation code not found. Please try again.",
    "notactive": "Simulation is not active.",
    "login": "Facilitator log in",
    "noie": "Internet Explorer browser is not supported and will not work. Please switch to a another browser.",
    "gamecode": "If you are joining the simulation as a player, you can join using a link provided by the facilitator. If you have received a simulation code,",
    "gamecodelink": "click here.",
    "nogamecode": "Simulation code is required",
    "closedreportingopen": "Simulation is closed, but you can view the reports using your personal link which has been emailed to all players.",
    "simulationadmin": "Simulations administration",
    "cannotjoinanymore": "Simulation has ended and cannot be joined anymore.",
    "observerfacilitator": "Logged in facilitator cannot join a game as an observer. Please open the link in your browser's incognito window."
  },
  "fi": {
    "entercode": "* Anna simulaation koodi",
    "submit": "Lähetä",
    "notfound": "Koodia ei ole olemassa. Yritä uudestaan.",
    "notactive": "Simulaatio ei ole aktiivinen.",
    "login": "Pelinjohtajan kirjautuminen",
    "noie": "Internet Explorer -selainta ei tueta, ja SmoothTeam ei toimi sen kanssa oikein. Ota käyttöön toinen selain.",
    "gamecode": "Jos olet osallistumassa simulaatioon pelaajana, pääset osallistumaan pelinjohtajan toimittamasta linkistä. Jos olet saanut simulaation koodin,",
    "gamecodelink": "klikkaa tästä.",
    "nogamecode": "Anna simulaation koodi",
    "closedreportingopen": "Simulaatio on suljettu, mutta voit tarkastella raportteja käyttäen henkilökohtaista linkkiäsi. Linkki on lähetetty sähköpostilla kaikille pelaajille.",
    "simulationadmin": "Simulaatioiden hallinta",
    "cannotjoinanymore": "Simulaatio on loppunut, eikä siihen voi enää liittyä.",
    "observerfacilitator": "Sisäänkirjautunut pelinjohtaja ei voi liittyä seuraamaan peliä. Avaa linkki uudestaan selaimen Incognito-ikkunassa."
  },
  "sv": {
    "entercode": "* Ange koden för simuleringen",
    "submit": "Skicka",
    "notfound": "Koden hittades inte. Försök igen.",
    "notactive": "Simulering är inte aktiv.",
    "login": "Spelladarens inloggning",
    "noie": "SmoothTeam fungerar inte korrekt med webbläsaren Interet Explorer. Välj en annan webbläsare.",
    "gamecode": "Om du går med i simuleringen som en spelare kan du gå med via en länk från spelledaren. Om du har fått en kod till simuleringen",
    "gamecodelink": "klicka här.",
    "nogamecode": "Ange koden för simuleringen",
    "closedreportingopen": "Simuleringen är stängd, men du kan se rapporterna via din personliga länk. Länken har skickats via e-post till alla spelare.",
    "simulationadmin": "Hantering av simuleringarna",
    "cannotjoinanymore": "Simuleringen har avslutats och går inte längre att ansluta till",
    "observerfacilitator": "En inloggad spelledare  kan inte gå med i ett spel som observatör. Öppna istället länken i din webbläsares inkognitoläge"
  },
  "de": {
    "entercode": "* Bitte geben Sie den Simulationscode ein",
    "submit": "Absenden",
    "notfound": "Simulationscode nicht gefunden. Bitte versuchen Sie es noch einmal.",
    "notactive": "Die Simulation ist nicht aktiv.",
    "login": "Moderator-Anmeldung",
    "noie": "Der Browser Internet Explorer wird nicht unterstützt und wird nicht funktionieren. Bitte wechseln Sie zu einem anderen Browser.",
    "gamecode": "Wenn Sie als Spieler an der Simulation teilnehmen, können Sie über einen vom Moderator bereitgestellten Link beitreten. Wenn Sie einen Simulationscode erhalten haben,",
    "gamecodelink": "klicke hier.",
    "nogamecode": "Simulationscode ist erforderlich",
    "closedreportingopen": "Die Simulation ist geschlossen, aber Sie können die Berichte über Ihren persönlichen Link anzeigen, der per E-Mail an alle Spieler gesendet wurde.",
    "simulationadmin": "Verwaltung der Simulationen",
    "cannotjoinanymore": "Die Simulation ist beendet und kann nicht mehr beigetreten werden.",
    "observerfacilitator": "Eingeloggter Moderator kann einem Spiel nicht als Beobachter beitreten. Bitte öffnen Sie den Link im Inkognito-Fenster Ihres Browsers."
  },
  "ko": {
    "entercode": "* 시뮬레이션 코드를 입력해주십시오.",
    "submit": "제출",
    "notfound": "시뮬레이션 코드가 올바르지 않습니다. 다시 입력해주십시오.",
    "notactive": "시뮬레이션 코드가 활성화되지 않았습니다.",
    "login": "퍼실리테이터 로그인",
    "noie": "인터넷익스플로러는 지원하지 않습니다. 다른 브라우저로 시도해주십시오.",
    "gamecode": "시뮬레이션 참가자는 퍼실리테이터(강의자)가 제공한 링크를 통해 접속하십시오. 접속코드를 갖고 계신다면",
    "gamecodelink": "이곳을 클릭하세요.",
    "nogamecode": "시뮬레이션 코드는 필수항목입니다.",
    "closedreportingopen": "시뮬레이션 코드가 비활성화되었습니다. 이메일로 전송된 개별 링크를 통해 결과를 확인하실 수 있습니다.",
    "simulationadmin": "시뮬레이션 관리",
    "cannotjoinanymore": "시뮬레이션이 종료되어 다시 접속하실 수 없습니다. ",
    "observerfacilitator": "이미 퍼실리테이터 계정으로 로그인되었기 때문에 관찰자 모드로 참여할 수 없습니다. 브라우저의 시크릿 모드로 다시 시도하십시오. "
  }
}
</i18n>
